const reviews = [
    // {
    //     reviewText: "You lot do some amazing, life saving work here. Thak you for being so professional and caring. We are feeling so much better because of you!",
    //     imagePath: './assets/pictures/review1.jpg'
    // },
    {
        reviewText: "On behalf of our cambodia people I would like to say thank you that you spend time to share knowledge related to newborn. I hope that you will come to our satellite again because we need you. at the end I wish you to have a safe trip.",
        imagePath: './assets/pictures/review2.jpg'
    },
    {
        reviewText: "On honor of SC staff, I would like to say thank you very much for your value time. We appreciate your team a lot, and of course, have gain knowledge gradually involving neonate because of yours. I'm sure, ahe, sc shall need your help, Please, please, continue supporting us as much as possible.",
        imagePath: './assets/pictures/review3.jpg'
    },
    // {
    //     reviewText: "We would like to express our heartfelt gratitude for all that you have done for [our child] and us. We will never forget the compassion you showed in creating the opportunity for her to give them a bath. Though our child was a Trisomy 18 baby, he was nonetheless fearfully and wonderfully made. We look forward to our reunion with our son in heaven! God bless you.",
    //     imagePath: './assets/pictures/review4.jpg'
    // },
    // {
    //     reviewText: "We really appreciate your effort for writing such a well-thought out and detailed medical report for our son. Thank you so much!",
    //     imagePath: './assets/pictures/review5.jpg'
    // },
    {
        reviewText: "Thank you for your help with all the children in this community",
    }
]

export default reviews;